var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('Header'),_c('div',{staticClass:"router-view-area"},[(_vm.canRender)?_vm._t("default"):_vm._e()],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }